export default "__VITE_ASSET__DLsXIfIE__"